



















































import Badge from './badge.component.vue';
import { UiIconButton } from './keen-ui';

interface Suggestion {
  value: string;
  label?: string;
}

export default {
  name: 'searchbox',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    help: {
      type: String
    },
    maxLength: {
      type: Number
    },
    size: {
      type: String, // 'medium' | 'large'
      default: 'medium'
    },
    suggestions: {
      type: Array, // Suggestion[]
      default: () => []
    },
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  components: {
    UiIconButton,
    Badge
  },
  computed: {
    classes: function (): string[] {
      return [
        this.baseClass,
        `${ this.baseClass }--${ this.size }`,
        {
          [`${ this.baseClass }--hovered`]: !this.disabled && this.hovered,
          [`${ this.baseClass }--focused`]: !this.disabled && this.focused,
          [`${ this.baseClass }--disabled`]: this.disabled
        }
      ];
    },
    clearIcon: function (): string {
      if (!!this.innerValue) {
        return 'close';
      }
      return 'search';
    },
    clearButtonSize: function (): string {
      if (this.size === 'large') {
        return 'normal';
      }
      return 'small';
    },
    helpBadgeSize: function (): string {
      if (this.size === 'large') {
        return 'small';
      }
      return 'mini';
    }
  },
  data: function () {
    return {
      baseClass: 'epb-searchbox',
      innerValue: undefined,
      hovered: false,
      focused: false,
      suggestionsVisible: false,
      highlightedSuggestionIndex: -1
    };
  },
  methods: {
    onFocus: function (): void {
      this.focused = true;
      this.openSuggestions();
    },
    openSuggestions: function (): void {
      if (this.suggestionsVisible) {
        return;
      }
      this.suggestionsVisible = true;
      this.$emit('suggestions-open');
    },
    onBlur: function (): void {
      this.focused = false;
    },
    input: function (value: string): void {
      this.innerValue = value;
      this.$emit('input', value);
    },
    onKeyboardEnter: function (event: KeyboardEvent): void {
      const highlightedSuggestion = this.suggestions[this.highlightedSuggestionIndex];
      if (!!highlightedSuggestion) {
        this.selectSuggestion(highlightedSuggestion);
      } else {
        this.change((event.target as HTMLInputElement).value);
      }
    },
    selectSuggestion: function (suggestion: Suggestion): void {
      this.$emit('select', suggestion.value);
      this.closeSuggestions();
    },
    closeSuggestions: function (): void {
      if (!this.suggestionsVisible) {
        return;
      }
      this.suggestionsVisible = false;
      this.highlightedSuggestionIndex = -1;
      this.$emit('suggestions-close');
    },
    change: function (value: string): void {
      if (value !== this.value) {
        this.$emit('change', value);
      }
    },
    highlightSuggestion: function (index: number): void {
      if (!this.suggestions.length) {
        return;
      }
      if (index === this.suggestions.length) {
        index = 0;
      } else if (index < 0) {
        index = (this.suggestions.length - 1);
      }
      this.highlightedSuggestionIndex = index;
      this.openSuggestions();
    },
    clear: function (): void {
      this.input('');
      this.change('');
    },
    getSuggestionClasses: function (suggestion: Suggestion, index: number) {
      const baseClass = `${ this.baseClass }__suggestion`;
      return [
        baseClass,
        {
          [`${ baseClass }--highlighted`]: index === this.highlightedSuggestionIndex
        }
      ];
    },
    onExternalClick: function (event: MouseEvent): void {
      if (!this.$el.contains(event.target)) {
        this.closeSuggestions();
      }
    }
  },
  mounted: function (): void {
    document.addEventListener('click', this.onExternalClick);
  },
  beforeDestroy: function (): void {
    document.removeEventListener('click', this.onExternalClick);
  },
  watch: {
    value: {
      handler: function (value: string): void {
        this.innerValue = value;
        if (this.focused) {
          this.openSuggestions();
        }
      },
      immediate: true
    },
    suggestions: {
      handler: function (): void {
        this.highlightedSuggestionIndex = -1;
      }
    }
  }
};

